"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VcfNotificationClient = void 0;
const headers = {
    'User-Id': '__userId__',
};
class VcfNotificationClient {
    constructor(authService, stage) {
        this.authService = authService;
        this.stage = stage;
        this.gdcTokenQueryString = (isWcar) => (isWcar ? `gdc=myvw-wcar-${this.stage}` : `gdc=myvw-mbb-${this.stage}`);
        this.resourceHostId = `myvw-vcf-${stage}`;
    }
    async getUserCapabilities(vin, isWcar) {
        let response;
        try {
            response = await this.authService.get(this.resourceHostId, `vehicles/${vin}/usercapabilities?${this.gdcTokenQueryString(isWcar)}`, headers);
        }
        catch (error) {
            throw new Error(error);
        }
        const json = await response.json();
        if (!response.ok) {
            throw new Error(await response.json());
        }
        return json;
    }
    async getTransactionHistory(vin, isWcar) {
        let response;
        try {
            response = await this.authService.get(this.resourceHostId, `vehicles/${vin}/transactionhistory?${this.gdcTokenQueryString(isWcar)}`, headers);
        }
        catch (error) {
            throw new Error(error);
        }
        if (response.status === 404) {
            return {
                data: {
                    messages: [],
                    errors: [],
                },
            };
        }
        const json = await response.json();
        if (!response.ok) {
            throw new Error(json);
        }
        return json;
    }
    async deleteTransactionHistory(vin, isWcar, category) {
        let response;
        try {
            response = await this.authService.delete(this.resourceHostId, `vehicles/${vin}/transactionhistory/${category}?${this.gdcTokenQueryString(isWcar)}`, undefined, headers);
        }
        catch (error) {
            throw new Error(error);
        }
        if (!response.ok) {
            throw new Error(await response.json());
        }
    }
    async getGeofenceNotifications(vin, isWcar) {
        let response;
        try {
            response = await this.authService.get(this.resourceHostId, `vehicles/${vin}/alerts/geofence?${this.gdcTokenQueryString(isWcar)}`, headers);
        }
        catch (error) {
            throw new Error(error);
        }
        if (response.status === 404) {
            return {
                data: {
                    carCapturedTimestamp: '',
                    maxDefinitions: 0,
                    maxActiveDefinitions: 0,
                    geofences: [],
                },
            };
        }
        const json = await response.json();
        if (!response.ok) {
            throw new Error(json);
        }
        return json;
    }
    async createGeofenceNotification(vin, isWcar, payload) {
        let response;
        try {
            response = await this.authService.post(this.resourceHostId, `vehicles/${vin}/alerts/geofence?${this.gdcTokenQueryString(isWcar)}`, JSON.stringify(payload), headers);
        }
        catch (error) {
            throw new Error(error);
        }
        const json = await response.json();
        if (!response.ok) {
            throw new Error(json);
        }
        return json;
    }
    async updateGeofenceNotification(vin, isWcar, payload) {
        let response;
        try {
            response = await this.authService.put(this.resourceHostId, `vehicles/${vin}/alerts/geofence?${this.gdcTokenQueryString(isWcar)}`, JSON.stringify(payload), headers);
        }
        catch (error) {
            throw new Error(error);
        }
        const json = await response.json();
        if (!response.ok) {
            throw new Error(json);
        }
        return json;
    }
    async deleteGeofenceNotification(vin, isWcar, id) {
        let response;
        try {
            response = await this.authService.delete(this.resourceHostId, `vehicles/${vin}/alerts/geofence/${id}?${this.gdcTokenQueryString(isWcar)}`, undefined, headers);
        }
        catch (error) {
            throw new Error(error);
        }
        const json = await response.json();
        if (!response.ok) {
            throw new Error(json);
        }
        return json;
    }
    async getSpeedAlertNotifications(vin, isWcar) {
        let response;
        try {
            response = await this.authService.get(this.resourceHostId, `vehicles/${vin}/alerts/speed?${this.gdcTokenQueryString(isWcar)}`, headers);
        }
        catch (error) {
            throw new Error(error);
        }
        if (response.status === 404) {
            return {
                data: {
                    carCapturedTimestamp: '',
                    maxDefinitions: 0,
                    maxActiveDefinitions: 0,
                    speedAlerts: [],
                },
            };
        }
        const json = await response.json();
        if (!response.ok) {
            throw new Error(json);
        }
        return json;
    }
    async createSpeedAlertNotification(vin, isWcar, payload) {
        let response;
        try {
            response = await this.authService.post(this.resourceHostId, `vehicles/${vin}/alerts/speed?${this.gdcTokenQueryString(isWcar)}`, JSON.stringify(payload), headers);
        }
        catch (error) {
            throw new Error(error);
        }
        const json = await response.json();
        if (!response.ok) {
            throw new Error(json);
        }
        return json;
    }
    async updateSpeedAlertNotification(vin, isWcar, payload) {
        let response;
        try {
            response = await this.authService.put(this.resourceHostId, `vehicles/${vin}/alerts/speed?${this.gdcTokenQueryString(isWcar)}`, JSON.stringify(payload), headers);
        }
        catch (error) {
            throw new Error(error);
        }
        const json = await response.json();
        if (!response.ok) {
            throw new Error(json);
        }
        return json;
    }
    async deleteSpeedAlertNotification(vin, isWcar, id) {
        let response;
        try {
            response = await this.authService.delete(this.resourceHostId, `vehicles/${vin}/alerts/speed/${id}/?${this.gdcTokenQueryString(isWcar)}`, undefined, headers);
        }
        catch (error) {
            throw new Error(error);
        }
        const json = await response.json();
        if (!response.ok) {
            throw new Error(json);
        }
        return json;
    }
    async getSubscriptionSettings(vin, isWcar) {
        let response;
        try {
            response = await this.authService.get(this.resourceHostId, `vehicles/${vin}/subscriptions/settings?${this.gdcTokenQueryString(isWcar)}`, headers);
        }
        catch (error) {
            throw new Error(error);
        }
        const json = await response.json();
        if (!response.ok) {
            throw new Error(json);
        }
        return json;
    }
    async updateSubscriptionSettings(vin, isWcar, payload) {
        let response;
        try {
            response = await this.authService.put(this.resourceHostId, `vehicles/${vin}/subscriptions/settings?${this.gdcTokenQueryString(isWcar)}`, JSON.stringify(payload), headers);
        }
        catch (error) {
            throw new Error(error);
        }
        if (!response.ok) {
            throw new Error(await response.json());
        }
    }
    async getNotificationConfigRequestStatus(vin, isWcar, category, requestId) {
        const response = await this.authService.get(this.resourceHostId, `vehicles/${vin}/alerts/${category}/requests/${requestId}?${this.gdcTokenQueryString(isWcar)}`, headers);
        if (!response.ok) {
            throw new Error(`Request failed with status code ${response.status}`);
        }
        return response.json();
    }
}
exports.VcfNotificationClient = VcfNotificationClient;
//# sourceMappingURL=VcfNotificationClient.js.map